import { render, staticRenderFns } from "./JobMaterialsBudgetSummary.vue?vue&type=template&id=34fda4b8&scoped=true&"
import script from "./JobMaterialsBudgetSummary.vue?vue&type=script&lang=js&"
export * from "./JobMaterialsBudgetSummary.vue?vue&type=script&lang=js&"
import style0 from "./JobMaterialsBudgetSummary.vue?vue&type=style&index=0&id=34fda4b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fda4b8",
  null
  
)

export default component.exports